import { render, staticRenderFns } from "./DateFieldWidget.component.html?vue&type=template&id=019dcc69&scoped=true&"
import script from "./DateFieldWidget.component.ts?vue&type=script&lang=ts&"
export * from "./DateFieldWidget.component.ts?vue&type=script&lang=ts&"
import style0 from "./DateFieldWidget.component.scss?vue&type=style&index=0&id=019dcc69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019dcc69",
  null
  
)

export default component.exports